import React, { FormEvent } from 'react';
import clsx from 'clsx';
import { Checkbox } from '../checkbox';


export interface IWaterFilter {
    filter: any;
    onFilterChange: (filterId: number, value: any, debounced?: boolean) => void;
    className?: string;
}

export const WaterFilter: React.FC<IWaterFilter> = (props): JSX.Element => {
    const { filter, onFilterChange, className } = props;

    const handleChange = (value: boolean) => {
        onFilterChange(
            filter.id,
            value,
            true
        );
    };

    return (
        <div className={clsx('objects-filter', 'object-filter-water', className)}>
            <div className="objects-filter__name">
                <Checkbox
                    checked={filter.value || false}
                    onChange={(e: FormEvent<HTMLInputElement>) => handleChange(e.target['checked'])}
                />
                {filter.name}
            </div>
        </div>
    );
};
